import { MeetingRoleType } from "types/originalTypes";

export const ADMINISTRATOR_GROUP_ID = "0";

export const MASTER_URL_DOWNLOAD_COLUMNS = [
  { header: "タイプ", key: "interview_role" },
  { header: "番号", key: "sort_index" },
  { header: "入室URL", key: "url" },
  { header: "PINコード", key: "pin_code" },
];

export const TEST_URL_DOWNLOAD_COLUMNS = [
  { header: "番号", key: "sort_index" },
  { header: "モニター用ＵＲＬ", key: "monitor_url" },
  { header: "テスト確認用ＵＲＬ", key: "tester_url" },
];

export const MONITOR_URL_DOWNLOAD_COLUMNS = [
  { header: "No.", key: "interview_seq" },
  { header: "実査日時", key: "interview_datetime" },
  { header: "URL連番", key: "sort_index" },
  { header: "入室URL", key: "url" },
  { header: "PINコード", key: "pin_code" },
];

export const CHAT_DATA_DOWNLOAD_COLUMNS = [
  { header: "投稿日時", key: "createdDate" },
  { header: "投稿者名", key: "attendeeName" },
  { header: "タイプ", key: "channelType" },
  { header: "メッセージ", key: "message" },
];

export const TEMPLATE_MONITOR_VARIABLE = `$\{${MeetingRoleType.MONITOR}}`;

export const TRANSLATE_MEETING_ROLE = {
  MODERATOR: "インタビュアー",
  MONITOR: "モニター",
};
